import Button from '#components/controls/button/Button';
import { useOvermindActions } from '#store/overmind';
import { PlayArrow } from '#components/icons';
import { ContentType } from '#types/generated/graphql-types';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  contentType: ContentType;
  mediaIri: string;
};

const MediaPreviewHeroButton = ({ contentType, mediaIri }: Props) => {
  const { t } = useTranslation();
  const { initPlayer } = useOvermindActions().player;

  return (
    <div className="tw-transition-opacity tw-duration-500 tw-opacity-100">
      <Button
        startIcon={<PlayArrow />}
        title={t('teaserButtonPlay')}
        onClick={() => {
          initPlayer({ iri: mediaIri, contentType });
        }}
      />
    </div>
  );
};

export default MediaPreviewHeroButton;
